import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { PsRevisionService } from '../../../services/ps-revision.service';
import { PSRevisionFormViewModel } from '../../../models/ps-revision';
import { ActivatedRoute } from '@angular/router';
import { PsRevisionRicsService } from '../../../services/ps-revision-rics.service';
import { ModelHelpers } from '../../../models/ModelHelpers';

@Component({
  selector: 'app-ps-revision',
  templateUrl: './ps-revision.component.html',
  styleUrls: ['./ps-revision.component.scss']
})
export class PsRevisionComponent implements OnInit {

  @Input() isEnCurso: boolean = false;

  formGroup: FormGroup;
  ricsFormGroup: FormGroup;
  idPs = -1; // Asigna el IDPS correspondiente
  ricsModel: any;
  errorMessage: string;
  isEdit: boolean = false;
  finalidadList: any;
  tipoInspeccionList: any;

  constructor(
    private fb: FormBuilder,
    private _avRoute: ActivatedRoute,
    private _psRevisionService: PsRevisionService,
    private _toastr: ToastrService,
    private _psRevisionRicsService: PsRevisionRicsService,
  ) {

    if (this._avRoute.snapshot.params['id']) {
      this.idPs = this._avRoute.snapshot.params['id'];
    }

    this.formGroup = this.fb.group({
      psAcuerdosBasicos: this.fb.array([]),
      psAcuerdosPosteriores: this.fb.array([]),
      psOtrosAspectosRelevantes: this.fb.array([]),
      psFechasFirma: this.fb.array([])
    });

    this.buildRicsForm();
  }

  get psAcuerdosBasicos() {
    return this.formGroup.get('psAcuerdosBasicos') as FormArray;
  }

  get psAcuerdosPosteriores() {
    return this.formGroup.get('psAcuerdosPosteriores') as FormArray;
  }

  get psOtrosAspectosRelevantes() {
    return this.formGroup.get('psOtrosAspectosRelevantes') as FormArray;
  }

  get psFechasFirma() {
    return this.formGroup.get('psFechasFirma') as FormArray;
  }

  ngOnInit(): void {

    this.loadData();
  }

  getFormArray(name: string): FormArray {
    return this.formGroup.get(name) as FormArray;
  }

  loadData() {
    this._psRevisionService.getViewModel(this.idPs).subscribe((data: PSRevisionFormViewModel) => {
      this.setFormArray(data.elementosAcordados_Basicos, 'psAcuerdosBasicos');
      this.setFormArray(data.elementosAcordados_Posteriores, 'psAcuerdosPosteriores');
      this.setFormArray(data.otrosAspectosRelevantes, 'psOtrosAspectosRelevantes');
      this.setFormArray(data.fechasFirmas, 'psFechasFirma');
    });

    this.loadDataRICS();
  }

  async reLoadData() {
    this._psRevisionService.getViewModel(this.idPs).subscribe((data: PSRevisionFormViewModel) => {
      const formArrayAcuerdosBasicos = this.formGroup.get('psAcuerdosBasicos') as FormArray;
      const formArrayAcuerdosPosteriores = this.formGroup.get('psAcuerdosPosteriores') as FormArray;
      formArrayAcuerdosBasicos.clear();
      formArrayAcuerdosPosteriores.clear();
      this.setFormArray(data.elementosAcordados_Basicos, 'psAcuerdosBasicos');
      this.setFormArray(data.elementosAcordados_Posteriores, 'psAcuerdosPosteriores');
    });
  }

  setFormArray(psList: any, psApartado: string): void {
    const formArray = this.formGroup.get(psApartado) as FormArray;
    psList.forEach(revision => {
      formArray.push(this.fb.group({
        id: [revision.id],
        idPS: this.idPs,
        tipoPrimario: [revision.tipoPrimario],
        tipoSecundario: [revision.tipoSecundario],
        tipoSecundarioLabel: [revision.tipoSecundarioLabel],
        idRelacionado: [revision.idRelacionado],
        // revisado: [revision.revisado],
        descripcion: [revision.descripcion],
        correccionesARealizar: [revision.correccionesARealizar]
      }));
    });
  }

  save(): void {
    var modifiedElements = [];
    modifiedElements = this.getModifiedElements();

    if (modifiedElements.length > 0 && this.isEnCurso) {
      this._psRevisionService.post(modifiedElements).subscribe(response => {
        console.log('Guardado con éxito:', response);
      }, error => {
        console.error('Error al guardar:', error);
        // this.mensaje = 'Error al guardar los cambios';
      });
    }
  }

  getModifiedElements() {
    const modifiedElements: any[] = [];
    const formArrayNames = ['psAcuerdosBasicos', 'psAcuerdosPosteriores', 'psOtrosAspectosRelevantes', 'psFechasFirma'];

    formArrayNames.forEach(arrayName => {
      const formArray = this.formGroup.get(arrayName) as FormArray;

      formArray.controls.forEach((control, index) => {
        if (control.dirty) {
          const element = {
            ...control.value,
            arrayName,
            index
          };
          modifiedElements.push(element);
        }
      });
    });

    return modifiedElements;
  }

  buildRicsForm() {
    this.ricsFormGroup = this.fb.group({
      idPs: [''],
      tipoInspeccion_Alcance: [''],
      tipoInspeccion_Supuestos: [''],
      aConsultar_Alcance: [''],
      aConsultar_Supuestos: [''],
      aInvestigar_Alcance: [''],
      aInvestigar_Supuestos: [''],
      noHacer_Alcance: [''],
      noHacer_Supuestos: [''],
      baseContratacionCompleta_Check: [false],
      baseContratacionCompleta_Comentario: [''],
      adecuacionTecnicoJustificada_Check: [false],
      adecuacionTecnicoJustificada_Comentario: [''],
      capacitacionTecnicoDetallada_Check: [false],
      capacitacionTecnicoDetallada_Comentario: [''],
      valoradorAsumeResponsabilidad_Check: [false],
      valoradorAsumeResponsabilidad_Comentario: [''],
      referenciaCorrecta_Check: [false],
      referenciaCorrecta_Comentario: [''],
      baseAcordada_ValorMercado: [false],
      baseAcordada_ValorRazonable: [false],
      baseAcordada_ValorRenta: [false],
      baseAcordada_ValorEquitativo: [false],
      baseAcordada_ValorInversion: [false],
      baseAcordada_ValorSinergico: [false],
      baseAcordada_ValorLiquidacion: [false],
      finalidad: [''],
      interesValorado: [''],
      objetoValorado: [''],
      fechaValor: [''],
      aspectosTecnicos_Testigos: [''],
      aspectosTecnicos_FichaInspeccion: [''],
      aspectosTecnicos_EstudioConflictos: ['']
    });
  }

  loadDataRICS() {
    // this.buildForm();
    this._psRevisionRicsService.get(this.idPs).subscribe(data => {
      this.ricsModel = data;
      // this.ricsModel.idPs = this.idPs;
      // console.log(this.ricsModel)
      this.ricsFormGroup.patchValue(data);
    });

    this._psRevisionRicsService.gettipoInspeccionList().subscribe(data => {
      this.tipoInspeccionList = data;
    })

    this._psRevisionRicsService.getFinalidadList().subscribe(data => {
      this.finalidadList = data;
    })
  }

  saveRICS() {

    if (!this.isEnCurso) return;

    this.errorMessage = null;
    ModelHelpers.copyFromForm(this.ricsFormGroup.value, this.ricsModel);

    if (!this.formGroup.valid) {
      this.errorMessage = 'Error de validación';
      return;
    }

    this._psRevisionRicsService.post(this.ricsModel)
      .subscribe((data: any) => {
        if (data.correct === false) {
          this.errorMessage = data.mensaje;
          return;
        }
        this._toastr.success("Guardado")
      }, err => {
        this.errorMessage = err.error.title;
        console.log(err)
        this._toastr.error(this.errorMessage)
      }
      );

  }

}
